var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "smallStempels text-center pointer",
      on: {
        click: function ($event) {
          return _vm.$ebus.$emit("goto", { name: "Stempelkarte" })
        },
      },
    },
    [
      _c("StempelAnzahl", { staticClass: "mb-2" }),
      _vm.$store.getters.loggedIn
        ? _c("div", [
            _vm.stempelCounter < 10
              ? _c("div", [
                  _vm._v(" Durch diese Bestellung sammelst du "),
                  _c("span", [
                    _c("b", [_vm._v(_vm._s(_vm.moreStempel) + " Stempel")]),
                  ]),
                ])
              : _vm._e(),
          ])
        : _c("div", [
            _c("div", [
              _vm._v("Registriere dich kostenlos, um Stempel zu sammeln"),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }